import React, { Component } from 'react';
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableFooter,
  TableHead,
  TablePagination,
  TableRow,
} from '@mui/material';
import { connect } from 'react-redux';
import withRouter from 'withRouter';
import { bindActionCreators } from 'redux';
import {
  getDashboardTab,
  getDashboardSummaryData,
  clearDashboardSummaryData,
  getReportDetails,
} from '../../actions/report';
import {
  getTeamUserDetails,
  getUserDesignationDetails,
} from '../../actions/home';
import { decodeAccessToken, dateFilterFormater, isNull } from 'utils/helper';
import moment from 'moment';
class SummaryDashboardTable extends Component<any, any> {
  state = {
    page: 0,
    rowsPerPage: 10,
    dynamicFilterFields: [],
    totalCount: 0,
    viewMode: 'TEAM',
    filterQuery: '',
    filterFrom: 0,
    filterTo: 0,
    reportTemplateFields: [],
  };

  componentDidMount() {
    const { router, dashboardTab } = this.props;
    const { templateId, teamId, dashboardName } = router.params;

    const locState = router.location?.state || {};
    const prevViewState = locState.previousViewState || {};

    const incomingViewMode = prevViewState.viewMode ?? locState.viewMode;
    const incomingFilter = prevViewState.filterQuery ?? locState.filterQuery;
    const incomingFilterFrom = locState.filterFrom;
    const incomingFilterTo = locState.filterTo;
    const incomingTotal = prevViewState.totalCount ?? locState.totalCount;

    this.setState(
      (prev: any) => ({
        ...prev,
        ...(typeof incomingTotal === 'number' && { totalCount: incomingTotal }),
        ...(incomingViewMode && { viewMode: incomingViewMode }),
        ...(incomingFilter && { filterQuery: incomingFilter }),
        ...(incomingFilterFrom && { filterFrom: incomingFilterFrom }),
        ...(incomingFilterTo && { filterTo: incomingFilterTo }),
      }),
      () => {
        this.props.getReportDetails(templateId, teamId, () => {
          if (!dashboardTab?.length) {
            this.props.getDashboardTab(templateId, teamId);
          } else {
            this.initDynamicFields(dashboardName, dashboardTab);
          }
          this.fetchSummary();
        });
      }
    );
  }

  componentDidUpdate(prevProps: any, prevState: any) {
    const { router, dashboardTab, userTeamDetails, reportDetails } = this.props;
    const { dashboardName, gk } = router.params;

    let shouldRefetch = false;

    if (
      prevState.page !== this.state.page ||
      prevState.rowsPerPage !== this.state.rowsPerPage
    ) {
      shouldRefetch = true;
    }

    if (
      prevProps.router.params.dashboardName !== dashboardName ||
      prevProps.router.params.gk !== gk
    ) {
      if (this.state.page !== 0) this.setState({ page: 0 });
      shouldRefetch = true;
    }

    if (prevProps.reportDetails !== reportDetails) {
      try {
        const template = reportDetails?.template
          ? JSON.parse(reportDetails.template)
          : null;
        if (template && template.fields) {
          this.setState({ reportTemplateFields: template.fields });
        }
      } catch (e) {
        console.error('Error parsing reportDetails template:', e);
        this.setState({ reportTemplateFields: [] });
      }
      if (dashboardTab) {
        this.initDynamicFields(dashboardName, dashboardTab);
      }
      shouldRefetch = true;
    } else if (prevProps.dashboardTab !== dashboardTab) {
      this.initDynamicFields(dashboardName, dashboardTab);
      shouldRefetch = true;
    }

    if (prevState.viewMode !== this.state.viewMode) {
      if (this.state.page !== 0) this.setState({ page: 0 });
      shouldRefetch = true;
    }

    if (
      userTeamDetails &&
      (!prevProps.userTeamDetails || prevProps.dashboardTab !== dashboardTab)
    ) {
      shouldRefetch = true;
    }

    if (shouldRefetch) this.fetchSummary();
  }

  componentWillUnmount() {
    this.props.clearDashboardSummaryData();
  }

  initDynamicFields = (dashName: string, tabs: any[]) => {
    const tab = tabs.find((t) => t.name === dashName);
    if (tab) {
      this.setState({ dynamicFilterFields: this.extractDynamicFields(tab) });
    }
  };

  dateFilterFormaterCustom = (
    label: string,
    custom?: { from: any; to: any }
  ): { from: string; to: string } => {
    if (label?.toLowerCase() === 'custom') {
      return {
        from: moment(custom?.from).startOf('day').toISOString(),
        to: moment(custom?.to).endOf('day').toISOString(),
      };
    }
    const { from, to } = dateFilterFormater(label);
    return { from, to };
  };

  pickDateRange = (templateId: string) => {
    try {
      const stored = JSON.parse(localStorage.getItem('filterObj') || '[]');
      const template = stored.find((t: any) => t.templateId === templateId);

      if (!template) return null;
      const dateField = [...template.filterFields]
        .filter((f: any) => f.type === 'date' && f.value)
        .pop();

      if (!dateField) return null;
      if (dateField.value === 'Custom') {
        return this.dateFilterFormaterCustom('custom', {
          from: dateField.from,
          to: dateField.to,
        });
      }
      return this.dateFilterFormaterCustom(dateField.value);
    } catch {
      return null;
    }
  };
  handleChangePage = (_e: any, newPage: number) => {
    this.setState({ page: newPage });
  };
  getReporteesParam = () => {
    const mode = (this.state.viewMode || '').toUpperCase();
    return mode === 'TEAM' ? 'ALL' : 'NONE';
  };

  getDesignationId = () => {
    const token = sessionStorage.getItem('accessToken');
    if (!token) return null;
    try {
      const payload = decodeAccessToken(token);
      return payload.did || null;
    } catch {
      return null;
    }
  };

  handleChangeRowsPerPage = (e: any) => {
    this.setState({
      rowsPerPage: parseInt(e.target.value, 10),
      page: 0,
    });
  };

  handleBack = () => {
    const { router } = this.props;
    const { teamId, templateId } = router.params;
    const dashboardPath = `/member/${teamId}/dashboard/${templateId}`;
    const locState = router.location?.state || {};
    const prevViewState = locState.previousViewState || {};
    const filterQuery = locState.filterQuery;
    const totalCount = locState.totalCount;
    router.navigate(dashboardPath, {
      state: {
        fromSummary: true,
        previousViewState: prevViewState,
        filterQuery,
        totalCount,
      },
    });
  };

  extractDynamicFields = (tab: any) => {
    try {
      const { summaryView = {} } = JSON.parse(tab.display_template || '{}');
      const dynamicFilterFields = Object.entries(summaryView).map(
        ([name, f]: any) => {
          const fieldKey = f.k?.replace('{{data.', '').replace('}}', '');
          return {
            key: fieldKey,
            label: f.l || f.k,
            type: f.t || 'string',
            isBullet: name === 'bullet_field',
          };
        }
      );
      return dynamicFilterFields;
    } catch {
      return [];
    }
  };

  getTemplateFieldLabel = (fieldKey: string) => {
    const { reportTemplateFields } = this.state;
    const fieldConfig: any = reportTemplateFields.find(
      (f: any) => f.name === fieldKey
    );
    return fieldConfig ? fieldConfig.label : null;
  };

  getFieldValue = (row: any, key: string, isBullet = false) => {
    if (isBullet) {
      const raw = row[key];
      const date = typeof raw === 'object' && raw?.value ? raw.value : raw;
      return date ? moment(date).format('Do MMM YY HH:mm') : 'NA';
    }
    const fieldConfig: any = this.state.reportTemplateFields.find(
      (f: any) => f.name === key
    );
    if (fieldConfig && fieldConfig.type === 'lookup' && !isNull(row[key])) {
      const lookupLabelKey = fieldConfig.labelKey;
      if (lookupLabelKey && row[key].hasOwnProperty(lookupLabelKey)) {
        return row[key][lookupLabelKey];
      }
    }

    if (row.hasOwnProperty(key)) return row[key];

    return key.split('.').reduce((obj, part) => obj?.[part] ?? null, row);
  };

  isNumericString: any = (v: string) => /^\d+(\.\d+)?$/.test(v);

  handleRowClick = (row: any) => {
    const instanceId = row.instance_id || row._id || null;

    if (!instanceId) return;

    const { teamId, templateId, dashboardName, gk } = this.props.router.params;
    this.props.router.navigate(
      `/member/${teamId}/inbox/${templateId}/details/${instanceId}`,
      {
        state: { returnPath: `dashboard/${dashboardName}`, gk },
      }
    );
  };

  getDesignationDisplayName = (designationId: any) => {
    const { allReportee, userTeamDetails } = this.props;

    if (userTeamDetails?.designation?.designation_id === designationId) {
      const alias =
        userTeamDetails.user_alias ||
        userTeamDetails.user?.user_alias ||
        userTeamDetails.user_name;
      return `${userTeamDetails.designation.designation_name || ''} (${alias})`;
    }

    const match = allReportee?.find(
      (rep: any) =>
        rep.designation_id === designationId ||
        rep.desig_id === designationId ||
        rep._id === designationId
    );

    if (!match) return '';

    const alias =
      match.user_alias ||
      match.user?.user_alias ||
      match.user_name ||
      match.user?.user_name;

    return `${match.designation_name || ''} (${alias || '—'})`;
  };

  fetchSummary = () => {
    const { page, rowsPerPage, filterFrom, filterTo } = this.state;
    const { templateId, dashboardName, gk } = this.props.router.params;

    let actualFrom = filterFrom;
    let actualTo = filterTo;
    if (!actualFrom || !actualTo) {
      const rangeFromLocalStorage = this.pickDateRange(templateId);
      if (rangeFromLocalStorage) {
        actualFrom = moment(rangeFromLocalStorage.from).valueOf();
        actualTo = moment(rangeFromLocalStorage.to).valueOf();
      } else {
        const defaultRange = dateFilterFormater('last 30 days');
        actualFrom = moment(defaultRange.from).valueOf();
        actualTo = moment(defaultRange.to).valueOf();
      }
    }
    const designationId = this.getDesignationId();
    this.props.fetchSummaryData({
      templateId,
      dashboardName,
      from: actualFrom,
      to: actualTo,
      designationId,
      page_number: page + 1,
      page_size: rowsPerPage,
      gk,
      filter: this.state.filterQuery,
      reportees: this.getReporteesParam(),
    });
  };
  render() {
    const { summaryData } = this.props;
    const { page, rowsPerPage, dynamicFilterFields } = this.state;
    const headers = dynamicFilterFields.length
      ? dynamicFilterFields.map((f: any) => f.label)
      : [];
    const raw: any[] = Array.isArray(summaryData)
      ? summaryData
      : Array.isArray(summaryData?.docs)
        ? summaryData.docs
        : Array.isArray(summaryData?.data)
          ? summaryData.data
          : [];

    const detailsData = raw.map((item: any) => {
      if (item.document) {
        return {
          ...item.document,
          ...(item.document.data || {}),
        };
      }

      if (item.data) {
        return {
          ...item,
          ...(item.data || {}),
        };
      }
      return item;
    });
    const paginatedData = detailsData;

    return (
      <div id="workflow-inbox-root">
        <div className="workflow-inbox-wrapper">
          <div className="workflow-inbox-header">
            <div className="workflow-inbox-title-wrapper">
              <i
                className="fas fa-arrow-left"
                style={{ paddingRight: 20, cursor: 'pointer' }}
                onClick={this.handleBack}
              />
              <p>Dashboard</p>
            </div>
          </div>
          <div className="workflow-inbox-content">
            <Paper className="paper-root overflowX">
              <Table className="table-wrapper">
                <TableHead className="tabel-head-wrapper">
                  <TableRow>
                    {headers.map((header: string, index: number) => (
                      <TableCell
                        key={`header-${index}`}
                        style={{ fontWeight: 'bold' }}
                      >
                        {header}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody className="tabel-body">
                  {paginatedData.length > 0 ? (
                    paginatedData.map((row: any, rowIndex: number) => (
                      <TableRow
                        key={`row-${rowIndex}`}
                        hover
                        style={{ cursor: 'pointer' }}
                        onClick={() => this.handleRowClick(row)}
                      >
                        {dynamicFilterFields.map(
                          (field: any, cellIndex: any) => {
                            const rawValue = this.getFieldValue(
                              row,
                              field.key,
                              field.isBullet
                            );
                            const style =
                              cellIndex === 0
                                ? {
                                    color: '#0d6efd',
                                    textDecoration: 'underline',
                                    cursor: 'pointer',
                                  }
                                : {};
                            let displayValue = '—';
                            if (isNull(rawValue)) {
                              displayValue = '—';
                            } else if (typeof rawValue === 'object') {
                              if (
                                'desig_id' in rawValue ||
                                'user_alias' in rawValue ||
                                'user_id' in rawValue
                              ) {
                                displayValue = this.getDesignationDisplayName(
                                  rawValue.desig_id || rawValue.user_id
                                );
                              } else {
                                const fieldConfig: any =
                                  this.state.reportTemplateFields.find(
                                    (f: any) => f.name === field.key
                                  );
                                if (
                                  fieldConfig &&
                                  fieldConfig.objectType &&
                                  fieldConfig.primaryKey &&
                                  rawValue[fieldConfig.primaryKey]
                                ) {
                                  displayValue =
                                    rawValue[fieldConfig.primaryKey];
                                } else {
                                  try {
                                    const values = Object.values(rawValue)
                                      .filter(
                                        (v) =>
                                          typeof v === 'string' ||
                                          typeof v === 'number' ||
                                          typeof v === 'boolean'
                                      )
                                      .join(', ');
                                    displayValue =
                                      values || JSON.stringify(rawValue);
                                  } catch (e) {
                                    console.error(
                                      'Error stringifying object in SummaryDashboardTable TableCell:',
                                      rawValue,
                                      e
                                    );
                                    displayValue = 'Invalid Object';
                                  }
                                }
                              }
                            } else if (
                              typeof rawValue === 'string' &&
                              /^\d{4}-\d{2}-\d{2}T/.test(rawValue) &&
                              !field.isBullet
                            ) {
                              displayValue =
                                moment(rawValue).format('Do MMM YY HH:mm');
                            } else {
                              displayValue = rawValue;
                            }

                            return (
                              <TableCell
                                key={`cell-${rowIndex}-${cellIndex}`}
                                style={style}
                              >
                                {displayValue}
                              </TableCell>
                            );
                          }
                        )}
                      </TableRow>
                    ))
                  ) : (
                    <TableRow>
                      <TableCell
                        colSpan={headers.length}
                        style={{ textAlign: 'center' }}
                      >
                        No data available
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
                <TableFooter className="tabel-footer">
                  <TableRow>
                    <TablePagination
                      rowsPerPageOptions={[10, 25, 50]}
                      count={this.state.totalCount}
                      rowsPerPage={rowsPerPage}
                      page={page}
                      onPageChange={this.handleChangePage}
                      onRowsPerPageChange={this.handleChangeRowsPerPage}
                    />
                  </TableRow>
                </TableFooter>
              </Table>
            </Paper>
          </div>
        </div>
      </div>
    );
  }
}
const mapStateToProps = (state: any) => {
  return {
    summaryData: state.reportReducer.getDashboardSummaryData,
    dashboardTab: state.reportReducer.dashboardTab,
    userTeamDetails: state.homeReducer.userTeamDetails,
    allReportee: state.reportReducer.allReportee,
    reportDetails: state.reportReducer.reportDetails,
  };
};

const mapDispatchToProps = (dispatch: any) =>
  bindActionCreators(
    {
      getDashboardTab,
      getTeamUserDetails,
      getUserDesignationDetails,
      fetchSummaryData: getDashboardSummaryData,
      clearDashboardSummaryData,
      getReportDetails,
    },
    dispatch
  );

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(SummaryDashboardTable)
);
